<script>
import {messagingBus} from '@/core/infrastructure/messaging/messaging'
import {eventBus} from '@/core/infrastructure/event-bus/event-bus'
import {authApi} from '@/core/application/components/auth/utils'

export default {
  name: 'EntryPoint',
  data() {
    return {
      externalUser: null,
      apiKey: null,
    }
  },
  computed: {
    isAuthorized() {
      return this.$store.getters.auth.isAuthorized || false
    },
  },
  created() {
    this.externalUser = this.$route.query.user
    this.apiKey = this.$route.query.api_key
    messagingBus.on('showScriptList', () => {
      this.$router.push({name: 'iframeScripts'})
    })
    messagingBus.on('showLoginForm', () => {
      this.$router.push({name: 'iframeLogin'})
    })
    messagingBus.on('runScript', arg => {
      this.$router.push({name: 'iframePass', params: {id: arg.id}})
    })
  },
  async mounted() {
    if(!this.isAuthorized) {
      // attempt to exchange external user and apikey to a hs jwt_token
      try {
        await authApi.post(`${process.env.VUE_APP_IFRAME_API}/api/user/authenticate`, {
          externalUser: this.$route.query.user,
          apiKey: this.$route.query.api_key,
        }, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        await this.$store.dispatch('app/TOGGLE_LOGIN_SIDEBAR', false)
        setTimeout(() => {
          eventBus.emit('getUserData')
        }, 1000)
      } catch (e) {
        console.error('IFRAME AUTHENTICATION error', e)
        eventBus.emit('toggleLogout')
        await this.$router.push({name: 'iframeLogin', query: {user: this.$route.query.user, api_key: this.$route.query.api_key}})
      }
    }
  },
}
</script>

<template>
  <div>
    <hyperscript-pass-core integration-type="iframe" />
  </div>
</template>

<style scoped>

</style>
